import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Send01Icon = (props?: SvgProps) => (
  <svg
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M20.6473 1.4745C20.8076 1.42796 21.1093 1.34853 21.4472 1.41786L21.5946 1.4579L21.7577 1.52235C22.0737 1.67093 22.3279 1.92603 22.4764 2.24208L22.5419 2.40517L22.5809 2.55165C22.6506 2.88992 22.5718 3.1921 22.5253 3.35243C22.4645 3.56151 22.365 3.8124 22.2675 4.06239L15.6776 20.9501C15.5686 21.2293 15.4632 21.5026 15.3602 21.7108C15.275 21.8833 15.0847 22.2496 14.6913 22.454C14.2574 22.6792 13.7411 22.6788 13.3075 22.453C12.9141 22.2481 12.7246 21.8813 12.6395 21.7089C12.5368 21.5005 12.4318 21.2275 12.3231 20.9481L9.72645 14.2724L3.05067 11.6767C2.77151 11.5681 2.4992 11.4629 2.2909 11.3602C2.11845 11.2752 1.75171 11.0856 1.54676 10.6923C1.32075 10.2585 1.32028 9.74157 1.54578 9.30751C1.75024 8.91412 2.11657 8.72478 2.28895 8.63954C2.49714 8.5366 2.76956 8.4311 3.04871 8.32216L19.9364 1.73134C20.1865 1.63375 20.4382 1.53525 20.6473 1.4745ZM11.6679 13.745L14.0009 19.744L19.3339 6.07899L11.6679 13.745ZM4.25477 9.99794L10.2528 12.3309L17.9179 4.66591L4.25477 9.99794Z"
      fill="#CBD5E1"
    />
  </svg>
)
